import React from 'react';

const JS_Quiz = () => {
  return (
    <div >
      <h1>JS_Quiz</h1>
      <p>Placeholder component for: "JS Quiz"</p>
    </div>
  );
};

export default JS_Quiz;
